import {
    initialFilter,
    FilterWorkplace,
    IFilter,
    FilterWorkGroup,
    FilterPosition,
    FilterTypeOfRepresentative,
    Idata,
    IdataTRfor,
    FilterTRFor,
    FilterUpdateStatus,
} from '../models/Filter'

import { Member } from '../models/Member'

export type IFilterData = {
    UdsoegteArbejdssteder: Idata[]
    UdsoegteFaggrupper: Idata[]
    UdsoegteStillinger: Idata[]
    UdsoegteTillidshverv: Idata[]
    TRTillidshvervMedlemLister: IdataTRfor[]
}

export function filterTypeOfRepresentative(
    pots: FilterTypeOfRepresentative[],
    items: Member[]
): Member[] {
    const filtered: Member[] = []

    items.forEach((member) => {
        return member.typeOfRepresentatives.forEach((pot) => {
            const isFound = pots.some((element) => {
                if (element.name === pot.name) {
                    return true
                }

                return false
            })

            if (isFound) {
                filtered.push(member)
            }
        })
    })

    return filtered
}

export function filterWorkplaces(
    workplaces: FilterWorkplace[],
    items: Member[]
): Member[] {
    const filtered: Member[] = []

    items.forEach((member) => {
        return member.workPlaces.forEach((workPlace) => {
            const isFound = workplaces.some((element) => {
                if (element.id === workPlace.number) {
                    return true
                }

                return false
            })

            if (isFound) {
                if (!filtered.find((m) => m.memberId === member.memberId)) {
                    filtered.push(member)
                }
            }
        })
    })

    return filtered
}

export function filterWorkgroups(
    workgroups: FilterWorkGroup[],
    items: Member[]
): Member[] {
    const filtered: Member[] = []

    items.forEach((member) => {
        return member.positions.forEach((position) => {
            const isFound = workgroups.some((element) => {
                if (element.id === position.group.id) {
                    return true
                }

                return false
            })

            if (isFound) {
                if (!filtered.find((m) => m.memberId === member.memberId)) {
                    filtered.push(member)
                }
            }
        })
    })

    return filtered
}

export function filterPositions(
    positions: FilterPosition[],
    items: Member[]
): Member[] {
    const filtered: Member[] = []

    items.forEach((member) => {
        return member.positions.forEach((position) => {
            const isFound = positions.some((element) => {
                if (element.id === position.id) {
                    return true
                }

                return false
            })

            if (isFound) {
                if (!filtered.find((m) => m.memberId === member.memberId)) {
                    filtered.push(member)
                }
            }
        })
    })

    return filtered
}

export function filterUpdateStatus(
    statuses: FilterUpdateStatus[],
    items: Member[]
): Member[] {
    const filtered: Member[] = []

    items.forEach((member) => {
        const isFound = statuses.some((element) => {
            if (element.id === member.status) {
                return true
            }

            return false
        })

        if (isFound) {
            filtered.push(member)
        }
    })

    return filtered
}

export function filterTRforHelper(
    trFor: FilterTRFor[],
    items: Member[]
): Member[] {
    const filtered: Member[] = []

    trFor.forEach((filter) => {
        filter.memberIds.forEach((id) => {
            const m = items.find((mem) => mem.memberId === id)

            if (m) filtered.push(m)
        })
    })

    return filtered
}

export function initFilter(data: IFilterData): IFilter {
    const filter = { ...initialFilter }

    if (data.UdsoegteArbejdssteder) {
        filter.workplaces = data.UdsoegteArbejdssteder.map((workPlace: Idata) =>
            FilterWorkplace.build(workPlace)
        )
    }

    if (data.UdsoegteFaggrupper) {
        filter.groups = data.UdsoegteFaggrupper.map((group: Idata) =>
            FilterWorkGroup.build(group)
        )
    }

    if (data.UdsoegteStillinger) {
        filter.positions = data.UdsoegteStillinger.map((position: Idata) =>
            FilterPosition.build(position)
        )
    }

    if (data.UdsoegteTillidshverv) {
        filter.typeOfRepresentative = data.UdsoegteTillidshverv.map(
            (trust: Idata) => FilterTypeOfRepresentative.build(trust)
        )
    }

    if (data.TRTillidshvervMedlemLister) {
        filter.representing = data.TRTillidshvervMedlemLister.map(
            (trfor: IdataTRfor) => FilterTRFor.build(trfor)
        )
    }

    return filter
}

export function filterItems(selected: IFilter, items: Member[]): Member[] {
    let filtered = [...items]

    if (selected.representing.length) {
        filtered = filterTRforHelper(selected.representing, filtered)
    }

    if (selected.workplaces.length) {
        filtered = filterWorkplaces(selected.workplaces, filtered)
    }

    if (selected.groups.length) {
        filtered = filterWorkgroups(selected.groups, filtered)
    }

    if (selected.positions.length) {
        filtered = filterPositions(selected.positions, filtered)
    }

    if (selected.typeOfRepresentative.length) {
        filtered = filterTypeOfRepresentative(
            selected.typeOfRepresentative,
            filtered
        )
    }

    if (selected.updateStatus.length) {
        filtered = filterUpdateStatus(selected.updateStatus, filtered)
    }

    return filtered
}

export function updateWorkplaces(
    workPlace: FilterWorkplace,
    selectedItems: IFilter
): IFilter {
    const selected = { ...selectedItems }

    const isFound = selected.workplaces.some((item) => item.id === workPlace.id)
    const workplaces = [...selectedItems.workplaces]

    if (isFound) {
        const indexOf = workplaces.findIndex((w) => w.id === workPlace.id)
        workplaces.splice(indexOf, 1)
        selected.workplaces = workplaces
    } else {
        workplaces.push(workPlace)
        selected.workplaces = workplaces
    }

    return selected
}

export function updatePositions(
    position: FilterPosition,
    selectedItems: IFilter
): IFilter {
    const selected = { ...selectedItems }

    const isFound = selected.positions.some((item) => item.id === position.id)
    const positions = [...selectedItems.positions]

    if (isFound) {
        const indexOf = positions.findIndex((w) => w.id === position.id)
        positions.splice(indexOf, 1)
        selected.positions = positions
    } else {
        positions.push(position)
        selected.positions = positions
    }

    return selected
}

export function updateTypeOfRepresentatives(
    position: FilterTypeOfRepresentative,
    selectedItems: IFilter
): IFilter {
    const selected = { ...selectedItems }

    const isFound = selected.typeOfRepresentative.some(
        (item) => item.name === position.name
    )
    const positions = [...selectedItems.typeOfRepresentative]

    if (isFound) {
        const indexOf = positions.findIndex((p) => p.name === position.name)
        positions.splice(indexOf, 1)
        selected.typeOfRepresentative = positions
    } else {
        positions.push(position)
        selected.typeOfRepresentative = positions
    }

    return selected
}

export function updateTRFor(
    duty: FilterTRFor,
    selectedItems: IFilter
): IFilter {
    const selected = { ...selectedItems }

    const isFound = selected.representing.some(
        (item) => item.name === duty.name
    )
    const trFors = [...selectedItems.representing]

    if (isFound) {
        const indexOf = trFors.findIndex((t) => t.name === duty.name)
        trFors.splice(indexOf, 1)
        selected.representing = trFors
    } else {
        trFors.push(duty)
        selected.representing = trFors
    }

    return selected
}

export function updateUpdateStatus(
    status: FilterUpdateStatus,
    selectedItems: IFilter
): IFilter {
    const selected = { ...selectedItems }

    const isFound = selected.updateStatus.some(
        (item) => item.name === status.name
    )
    const statuses = [...selectedItems.updateStatus]

    if (isFound) {
        const indexOf = statuses.findIndex((s) => s.name === status.name)
        statuses.splice(indexOf, 1)
        selected.updateStatus = statuses
    } else {
        statuses.push(status)
        selected.updateStatus = statuses
    }

    return selected
}

export function updateGroups(
    group: FilterWorkGroup,
    selectedItems: IFilter
): IFilter {
    const selected = { ...selectedItems }
    const isFound = selected.groups.some((item) => item.id === group.id)
    const groups = [...selectedItems.groups]

    if (isFound) {
        const indexOf = groups.findIndex((w) => w.id === group.id)
        groups.splice(indexOf, 1)
        selected.groups = groups
    } else {
        groups.push(group)
        selected.groups = groups
    }

    return selected
}
